var topo = $('.topo');
var alturaTopo = topo.height();
$(window).scroll(function(){
	if($(this).scrollTop() > alturaTopo){
		topo.addClass('fx');
	}else{
		topo.removeClass('fx');
	}
});